import { PageRef } from 'providers/page-ref';
import { Equipment } from '@cf-shared/data-model/equipment';

export type EquipmentScannerPageParams = {
  returnCallback?: string;
  local?: {
    /** Draft to scan into. When omitted, the page runs in auto-detect mode and the result `updatedDraft`
     *  is a fresh equipment of the AI-detected type (caller has no existing values to merge). */
    equipmentDraft?: Equipment;
  };
};

export type EquipmentScannerPageResult = {
  updatedDraft: Equipment;
};

export const IEquipmentScannerPage: PageRef<EquipmentScannerPageParams, EquipmentScannerPageResult> = {
  pageName: 'EquipmentScannerPage',
} as PageRef<EquipmentScannerPageParams, EquipmentScannerPageResult>;
